import {Hub} from 'yougile-model'
import {useForceUpdate, useSyncEvent} from '@containers/hooks'

export const useRefreshWhenUpdatedMirrors = (props: {task?: Hub}): void => {
  const forceUpdate = useForceUpdate()

  const filter = [...(props.task?.data?.mirrors || [])]

  useSyncEvent(
    'current',
    {
      debounceTime: 50,
      filter: filter
    },
    () => {
      forceUpdate()
    },
    [JSON.stringify(filter)]
  )
}
